/**
 * Adzuki core
 */

window.Adzuki = (function Adzuki()
{
	"use strict";

	// these are set in layouts
	var adzuki = {
		app        : null,
		base_uri   : false,
		dev        : false,
		init_page  : null, // used for Adzuki.onload()
		user_agent : navigator.userAgent || navigator.vendor,
		is_mobile  : false,
		gpt_enabled: 0,
	};

	var initialized = false;
	var initialized_on;

	// in order to avoid having 3 separate FontAwesome icon mappings (php, js, scss),
	// this list gets populated using the HtmlComponent->icon array.
	// these are done in the apps main layout template.
	var $mapping = $('.icon-mapping');
	adzuki.Icons = $mapping.data('icon-mapping');

	// "fun" fact: microsoft added the word "iPhone" to IE11's user agent,
	// that's why window.MSStream is being tested too. ¯\_(ツ)_/¯
	// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
	adzuki.is_mobile = ((/iPad|iPhone|iPod|android/).test(adzuki.user_agent) && !window.MSStream);

	// set global var for gpt being used by franchise
	adzuki.gpt_enabled = $('#gpt_enabled').data('enabled');

	// private, goodbye world
	// var goodbye = function goodbye() {
	//     console.log('goodbye world :(');
	// };

	// public, hello world
	adzuki.hello = function hello() {
		console.log('adzuki construct - hello world!');
	};


	// resolves relative urls
	adzuki.get_url = function get_url(url)
	{
		// eslint-disable-next-line no-magic-numbers
		if (url.charAt(0) === '/') {
			return adzuki.base_uri + url;
		}

		return url;
	};

	// this method is used to define code to be run when a specific page loads.
	// page - Controller/Method identifier. ex. Franchises/Edit, to only run on that page
	adzuki.onload = function onload(page, cb, block_on_init)
	{
		var _page          = page,
		    _block_on_init = (typeof block_on_init === 'undefined') ? true : block_on_init,
		    i;

		// edge-case: two separate files both have the same onload page.
		// example: one page with two forms, each with their own .js file.
		// _block_on_init, when set to false on the second-executed onload, should
		// allow the second to execute as well.
		if (initialized && _block_on_init) {
			if (_block_on_init && initialized_on === _page) {
				console.error('Duplicate Adzuki.onload for', _page, ', did you forget to set block_on_init? See https://confluence.cruiseplannersnet.com/pages/viewpage.action?pageId=28409896');
			}
			return;
		}

		if (_page instanceof Array)
		{
			for (i = 0; i < _page.length; i++)
			{
				if (typeof _page[i] === 'object')
				{
					if (this.init_page.match(_page[i])) {
						initialized    = true;
						initialized_on = _page;
						cb();
						break;
					}
				}
				else
				{
					_page[i] = strip_page(_page[i]);

					// this.init_page is defined in *MainLayoutTemplate.php
					if (this.init_page === _page[i]) {
						initialized    = true;
						initialized_on = _page;
						cb();
						break;
					}
				}
			}
		}
		else if (typeof _page === 'object')
		{
			if (this.init_page.match(_page)) {
				initialized    = true;
				initialized_on = _page;
				cb();
			}
		}
		else
		{
			_page = strip_page(_page);

			// this.init_page is defined in *MainLayoutTemplate.php
			if (this.init_page === _page) {
				initialized    = true;
				initialized_on = _page;
				cb();
			}
		}
	};

	function strip_page(page)
	{
		var _page = page;

		// remove leading / if it exists
		if (_page.charAt(0) === '/') {
			_page = _page.substr(1, _page.length);
		}

		// remove trailing / if it exists
		if (_page.charAt(_page.length-1) === '/') {
			_page = _page.substr(0, _page.length-1);
		}

		return _page;
	}

	// expose this object and its properties/methods
	return adzuki;
}());